"use client";

// i18n helper for variable interpolation

import type { LocalizedText } from "../types/schema";

export function t(text: LocalizedText, locale = "en", variables?: Record<string, string>): string {
  let result = text[locale] || text.en || Object.values(text)[0] || "";

  if (variables) {
    Object.entries(variables).forEach(([key, value]) => {
      result = result.replace(new RegExp(`\\{${key}\\}`, "g"), value);
    });
  }

  return result;
}

export function useLocale(locale = "en") {
  return {
    locale,
    t: (text: LocalizedText, variables?: Record<string, string>) => t(text, locale, variables),
  };
}
